"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllUserRounds = void 0;
const helpers_1 = require("../../../helpers");
const bs58_1 = __importDefault(require("bs58"));
const js_sha256_1 = require("js-sha256");
const bufferLayouts_1 = require("../../../bufferLayouts");
const getAllUserRounds = (programId, connection) => __awaiter(void 0, void 0, void 0, function* () {
    const program = yield (0, helpers_1.returnAnchorProgram)(programId, connection);
    const discriminator = Buffer.from(js_sha256_1.sha256.digest("account:UserRound")).subarray(0, 8);
    const userRounds = yield Promise.all((yield connection.getProgramAccounts(programId, {
        filters: [
            { memcmp: { offset: 0, bytes: bs58_1.default.encode(discriminator) } },
        ],
    }))
        .map((userRound) => __awaiter(void 0, void 0, void 0, function* () {
        let encodeUserRoundData = userRound.account.data.slice(8);
        const decoded = bufferLayouts_1.UserRoundRawLayout.decode(encodeUserRoundData, 0);
        return {
            round: decoded.round.toBase58(),
            solDeposited: Number(decoded.solDeposited),
            startSolPosition: Number(decoded.startSolPosition),
            user: decoded.user.toBase58(),
            lastTransactedAt: Number(decoded.lastTransactedAt),
            depositedAt: Number(decoded.depositedAt),
            nftMint: decoded.nftMint.toString(),
            jackpotSolAmount: Number(decoded.jackpotSolAmount),
            jackpotClaimedAt: Number(decoded.jackpotClaimedAt),
            jackpotClaimed: decoded.jackpotClaimed,
            placeholderOne: 0,
            placeholderTwo: 0,
            placeholderThree: false,
            placeholderFour: false,
            placeholderFive: false,
            publicKey: userRound.pubkey.toBase58()
        };
    })));
    return userRounds;
});
exports.getAllUserRounds = getAllUserRounds;
